export default [
    {
        to: "/account/my-perks/new",
        label: "perks.myPerks.navigation.newPerks"
    },
    {
        to: "/account/my-perks/used",
        label: "perks.myPerks.navigation.usedPerks"
    }
];
